__turbopack_context__.v({
  "addButton": "AddOnList-module__OGDGZa__addButton",
  "addOnContainer": "AddOnList-module__OGDGZa__addOnContainer",
  "addOnDescription": "AddOnList-module__OGDGZa__addOnDescription",
  "addOnHeader": "AddOnList-module__OGDGZa__addOnHeader",
  "addOnInfo": "AddOnList-module__OGDGZa__addOnInfo",
  "addOnPrice": "AddOnList-module__OGDGZa__addOnPrice",
  "addOnTitle": "AddOnList-module__OGDGZa__addOnTitle",
  "parameter": "AddOnList-module__OGDGZa__parameter",
  "parameterSection": "AddOnList-module__OGDGZa__parameterSection",
  "parametersList": "AddOnList-module__OGDGZa__parametersList",
  "viewParametersButton": "AddOnList-module__OGDGZa__viewParametersButton",
});
